import { defineStore } from "pinia";
import { type Ref, ref, computed } from "vue";

type FeaturesSetup = Record<string, boolean>;

interface Feature {
  key: string;
  enabled: boolean;
}

export const useFeaturesStore = defineStore("features", () => {
  const featuresSetup: Ref<FeaturesSetup> = ref({});

  const addFeatures = (features: Feature[]) => {
    const next: FeaturesSetup = {};
    features.forEach(feature => (next[feature.key] = feature.enabled));
    featuresSetup.value = next;
  };

  const isFeatureEnabled = computed(() => (featureName: string): boolean => {
    return !!featuresSetup.value[featureName];
  });

  return {
    featuresSetup,
    addFeatures,
    isFeatureEnabled
  };
});
